import { BottomFillIcon, CheckedFillIcon, ConfirmFillIcon, CrossIcon, RoundIcon } from "@t8891/icon";
import { Popup } from "@t8891/mobile";
import { Button } from "@t8891/pc";
import { useSetState } from "ahooks";
import React, { useEffect, useRef } from "react";
import { collectDefaultItems, itemIdValueEqual, mergeUnique } from "utils/InquiryLogistics";
import MaskShade from "./Mask";

function handleSelection(arr: any, inputItem: any) {
  // 深拷贝数组避免污染原数据
  let newArr = [...arr];
  const inputGroup = inputItem.group;

  // 条件1：存在相同value则移除，否则添加
  const existingIndex = newArr.findIndex((item) => item.value === inputItem.value);
  if (existingIndex > -1) {
    newArr.splice(existingIndex, 1);
  } else {
    newArr.push(inputItem);
  }

  // 条件2：移除不同group的项
  newArr = newArr.filter((item) => item.group === inputGroup);

  return newArr;
}

const Item: React.FC<any> = ({ label, onClick }) => {
  return (
    <div className=' h-32 text-[#333] text-14 bg-[#F5F5F5] inline-flex gap-6 items-center px-8 rounded-4'>
      {label} <CrossIcon size={14} strokeWidth={5} onClick={onClick} />
    </div>
  );
};

const TimeList: React.FC<any> = ({ temporaryArr, options, onChange, itemId }: any) => {
  return (
    <div>
      {options.map((item: any, index: number) => (
        <div
          className='flex-wrap gap-8 items-center '
          key={index}
          onClick={() => {
            onChange(item);
          }}
        >
          <div className='px-20 flex gap-4 items-center cursor-pointer h-34 hover:bg-[#F5F5F5]'>
            <div className='flex items-center'>
              {itemIdValueEqual({ formParams: temporaryArr, itemId: itemId, value: item.value }) ? (
                <ConfirmFillIcon size={18} fill='#3264FF' />
              ) : (
                <RoundIcon size={18} />
              )}
            </div>
            <div
              className={`text-14 ${
                itemIdValueEqual({ formParams: temporaryArr, itemId: itemId, value: item.value })
                  ? "text-[#3264FF]"
                  : "text-[#333]"
              }`}
            >
              {item.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const MultiSelect: React.FC<any> = ({ item, formParams, onChange, parentItemId }) => {
  const { title, options, itemId, required } = item;
  const [params, setParams] = useSetState<any>({
    visible: false,
    arr: [],
    temporaryArr: [],
  });
  const { visible, arr, temporaryArr } = params;

  useEffect(() => {
    if (formParams?.length) {
      const resultItems = collectDefaultItems([item]);

      let result = formParams.filter((item: any) => item.itemId === itemId);

      const mergedArray = mergeUnique(resultItems, result);

      setParams({ arr: mergedArray });
      onChange(resultItems, "multi-select");
    }
  }, []);
  let isChiildren = parentItemId === item.itemId;
  return (
    <div className='relative'>
      {/* 多选显示框 */}
      <div className={`${isChiildren ? "grid" : "flex"}  gap-12 items-center`}>
        <div className={`${isChiildren ? "text-16 font-[600]" : "text-14  h-40"} flex whitespace-pre items-center`}>
          {!!required && (
            <div className='flex items-center'>
              <div className='text-[#FF0000] text-16 h-10'>*</div>
            </div>
          )}
          {title}
        </div>
        <div className='relative'>
          {visible && (
            <MaskShade
              visible={visible}
              onClick={() => {
                setParams({ visible: false });
              }}
            >
              <div
                className='absolute top-50 z-[102] w-[270px] min-h-160 bg-white py-4 rounded-4'
                style={{
                  boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.10)",
                }}
              >
                <div id='multi-select-popup' className='py-8'>
                  <TimeList
                    temporaryArr={temporaryArr}
                    options={options}
                    itemId={itemId}
                    onChange={(val: any) => {
                      val.parentItemId = parentItemId;
                      val.itemId = itemId;
                      val.type = "multi-select";
                      let result = handleSelection(temporaryArr, val);
                      setParams({
                        temporaryArr: result,
                      });
                    }}
                  />
                  <div className='px-24 mt-8'>
                    <Button
                      size='middle'
                      disabled={!temporaryArr.length}
                      block
                      style={{ fontSize: "14px" }}
                      round={false}
                      type='primary'
                      onClick={() => {
                        setParams({ visible: false, arr: temporaryArr });

                        onChange(temporaryArr, "multi-select");
                      }}
                    >
                      提交
                    </Button>
                  </div>
                </div>
              </div>
            </MaskShade>
          )}
          <div
            className={`${arr?.length === 0 ? "items-center pl-10 text-[#BBB]" : "flex-wrap"}  rounded-4 p-4  ${
              isChiildren ? "w-[436px] mt-8" : "w-[300px]"
            }  pr-12 inline-flex gap-4 min-h-40 relative cursor-pointer`}
            style={{ border: "1px solid #E8E8E8" }}
            onClick={(e) => {
              e.stopPropagation();
              setParams({ visible: true, temporaryArr: arr });
            }}
          >
            {arr?.length === 0
              ? item.placeholder
              : arr.map((item: any, index: number) => (
                  <Item
                    onClick={(e: any) => {
                      e.stopPropagation();

                      let result = arr.filter((vv: any) => vv.value !== item.value);

                      setParams({ visible: false, arr: result });

                      onChange(result, "multi-select");
                    }}
                    label={item.label}
                    key={index}
                  />
                ))}

            <BottomFillIcon
              style={{
                transform: `rotate(${visible ? "180" : "0"}deg)`,
              }}
              className='absolute right-8 top-12 z-1'
              size={20}
              fill='#818181'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MultiSelect;
